import React from 'react';

import isNil from 'lodash/isNil';

import { Select } from '@gogame/components';
import { FormField, omitFormProps, withFormField } from '@gogame/form';

import {
  loadApplications,
  loadNetworks,
  loadPlatforms,
  loadClusters,
} from 'scenes/Integrations/sources/postbacks/fields';
import {
  getOptionValueInteger,
  getOptionLabelInteger,
  getOptionIdentity,
} from 'scenes/Integrations/utils';

import {
  TARGET_APPLICATION,
  TARGET_PLATFORM,
  TARGET_NETWORK,
  TARGET_CLUSTER,
  TARGET_REGISTRATION_PLATFORM,
} from '../constants';

const EMPTY_OPTIONS = [];

const SelectArray = withFormField()(({ area, value, onChange, ...props }) => {
  const handleChange = React.useCallback(
    (e, value) => onChange(e, [value]),
    [onChange]
  );

  return (
    <Select
      {...omitFormProps(props)}
      value={value?.[0]}
      label={'Entity'}
      onChange={handleChange}
      loading={area.loading}
      options={area.data || EMPTY_OPTIONS}
    />
  );
});

export default ({ target, ...props }) => {
  if (isNil(target)) {
    return <SelectArray {...props} disabled={true} />;
  }

  // TODO: remove after implement feedback
  if (target === TARGET_APPLICATION) {
    return <SelectArray source={loadApplications} {...props} />;
  }

  if (target === TARGET_NETWORK) {
    return <SelectArray source={loadNetworks} {...props} />;
  }

  if (target === TARGET_PLATFORM || target === TARGET_REGISTRATION_PLATFORM) {
    return <SelectArray source={loadPlatforms} {...props} />;
  }

  if (target === TARGET_CLUSTER) {
    return <SelectArray source={loadClusters} {...props} />;
  }

  return (
    <FormField.ChipsInput
      freeSolo={true}
      autoSelect={true}
      plainValue={true}
      getOptionValue={getOptionValueInteger}
      getOptionLabel={getOptionLabelInteger}
      createOption={getOptionIdentity}
      {...props}
    />
  );
};
